/**
 * @fileoverview EditTypeSelector Component
 *
 * Handles transaction type and user selection for edit mode with toggle switch support.
 * Used in the edit transaction modal to allow changing transaction type and user.
 *
 * @module components/TransactionList/EditTypeSelector
 */
import ToggleSwitch from '../shared/ToggleSwitch';
import styles from './EditTypeSelector.module.css';

/**
 * EditTypeSelector Component
 *
 * Handles the transaction type and user selection for edit mode
 */
function EditTypeSelector({
    transactionType,
    currentUser,
    paidDirectly,
    users,
    errors,
    onTypeChange,
    onUserChange,
    onPaidDirectlyChange,
    clearError
}) {
    const handleTypeChange = (value) => {
        onTypeChange(value);
        clearError('transactionType');
    };

    const handleUserChange = (value) => {
        onUserChange(value);
        clearError('currentUser');
    };

    const getUserPromptText = () => {
        if (transactionType === 'Income') return 'Who received?';
        if (transactionType === 'Expense') return 'Who paid?';
        return 'Who initiated?';
    };

    return (
        <div className={styles.container}>
            <label className={styles.label}>Type:</label>
            <select
                value={transactionType}
                onChange={(e) => handleTypeChange(e.target.value)}
                className={`${styles.typeSelect} ${errors.transactionType ? styles.error : ''}`}
            >
                <option value="">Select Type</option>
                <option value="Expense">Expense</option>
                <option value="Income">Income</option>
                <option value="Transfer">Transfer</option>
                <option value="Adjustment">Adjustment</option>
            </select>

            {transactionType && (
                <div className={styles.userSection}>
                    <label className={styles.label}>
                        {getUserPromptText()}:
                    </label>
                    <select
                        value={currentUser}
                        onChange={(e) => handleUserChange(e.target.value)}
                        className={styles.userSelect}
                    >
                        <option value="">Select user</option>
                        {users.map(user => (
                            <option key={user} value={user}>{user}</option>
                        ))}
                    </select>

                    {transactionType === 'Expense' && (
                        <ToggleSwitch
                            checked={paidDirectly}
                            onChange={onPaidDirectlyChange}
                            label="Paid directly from joint account"
                        />
                    )}
                </div>
            )}
        </div>
    );
}

export default EditTypeSelector;
